/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// reactstrap components
import { useAuth } from "context/AuthProvider";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Col,
} from "reactstrap";
import { apiLoginService } from "services/apiLoginService";
import { showAppAlert } from "components/common/AppAlerts";
import Auth from "layouts/Auth";

const LoginEmpresa = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [empresa, setEmpresa] = useState("")
  const [contrasnya, setContrasenya] = useState()

  const handleOnSubmit = async (e) =>{
    e.preventDefault();

    const json = {
      username: empresa,
      password: contrasnya,
      empresaNombre: empresa
    }
    try {

    const responseLogin = await apiLoginService.postLogin(json);
    if(responseLogin?.token !==null){
      localStorage.setItem("token", responseLogin.token)
      localStorage.setItem("tenant", empresa)
      localStorage.setItem("tenant_id", responseLogin.empresaId)
      
      login({
        id: responseLogin.empresaId,
        nombre: empresa,
        token: responseLogin.token,
        userId: responseLogin.userId
      })
      navigate("/admin/index")
      
    }else{
      throw new Error("Error al obtener el token")
    }
    } catch (error) {
      showAppAlert("Error al iniciar sesión: " + error.message, "error");
      return;
    }

    

  
  }

  return (
    <>
    <Auth >
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-0">
          <CardHeader className="bg-transparent text-center ">
            <h2>Acceso de empresa: </h2>
          </CardHeader>
          <CardBody className="">
            <div className="text-center text-muted mb-4">
              <small>Introduza sus credenciales</small>
            </div>
            <Form role="form" onSubmit={handleOnSubmit}>
            <FormGroup className="mb-3">
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-building" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Usuario"
                    value={empresa}
                    onChange={(e) => setEmpresa(e.target.value)}
                    type="text"
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend">
                    <InputGroupText>
                      <i className="ni ni-lock-circle-open" />
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    placeholder="Contraseña"
                    type="password"
                    value={contrasnya}
                    onChange={(e) => setContrasenya(e.target.value)}
                  />
                </InputGroup>
              </FormGroup>
             
              <div className="text-center">
                <Button className="my-4" color="primary" type="submit">
                  Iniciar sesión
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>
        
      </Col>
    </Auth>
    </>
  );
};

export default LoginEmpresa;


